// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"_1nbfA","faq-wrapper":"_3t2sp"};